import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface IProps {
	className?: string;
	el?: string;
	children: React.ReactNode;
}

/**
 * React portal based on https://stackoverflow.com/a/59154364
 * @param children Child elements
 * @param className CSS classname
 * @param el HTML element to create.  default: div
 */
const Portal: React.FC<IProps> = ({ children, className, el = 'div' }: IProps) => {
	const [container] = React.useState(document.createElement(el));

	if (!className) {
		className = 'portal';
	}
	className.split(/\s/g).forEach((className) => container.classList.add(className));

	React.useEffect(() => {
		document.body.appendChild(container);
		return () => {
			document.body.removeChild(container);
		};
	}, [container]);

	return ReactDOM.createPortal(children, container);
};

export default Portal;
